module.exports = (parcelRequire.load("cvHoC")).then(() => parcelRequire('gH9OH'));